// Shared styling for the selector's clickable rows (recents + tree nodes) and
// its section headers, so the two row sources stay visually identical.
export const sectionLabel =
  'text-muted-foreground px-1 pt-1 text-[10px] font-semibold tracking-wider uppercase'

export const rowClass =
  'flex w-full items-center gap-2 rounded-md px-2 py-1 text-left text-xs text-foreground transition-colors hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-inset data-[highlighted]:bg-muted data-[selected=true]:bg-primary/10 data-[selected=true]:font-medium'
